import { render } from "./RcS3Config.vue?vue&type=template&id=12cbe9d5&scoped=true"
import script from "./RcS3Config.vue?vue&type=script&lang=js"
export * from "./RcS3Config.vue?vue&type=script&lang=js"

import "./RcS3Config.vue?vue&type=style&index=0&id=12cbe9d5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cbe9d5"]])

export default __exports__